export default __webpack_public_path__ + "static/pahud-f0c19d0c90b8a60fe6ea9c9c2848de29.jpg";